// export const customWebsitePackages = [
//     {
//         title: 'Promo',
//         originalPrice: '198',
//         price: '99',
//         btnText: 'Get Started',
//         featuresHeading: 'Perfect for Describe who it fits',
//         featuresList: [
//             '1 Page Website',
//             '2 Stock Images',
//             '1 jQuery Slider Banner',
//             'Contact/Query Form',
//             '48 to 72 hours TAT',
//             'Complete Deployment',
//             '100% Satisfaction Guarantee',
//             '100% Unique Design Guarantee',
//             '100% Money Back Guarantee'
//         ]
//     },
//     {
//         title: 'Basic',
//         originalPrice: '388',
//         price: '194',
//         btnText: 'Get Started',
//         featuresHeading: 'Perfect for Describe who it fits',
//         featuresList: [
//             '1 Page Website',
//             '2 Stock Images',
//             '1 jQuery Slider Banner',
//             'Contact/Query Form',
//             '48 to 72 hours TAT',
//             'Complete Deployment',
//             '100% Satisfaction Guarantee',
//             '100% Unique Design Guarantee',
//             '100% Money Back Guarantee'
//         ]
//     },
//     {
//         title: 'Startup',
//         originalPrice: '788',
//         price: '394',
//         btnText: 'Get Started',
//         featuresHeading: 'Perfect for Describe who it fits',
//         featuresList: [
//             '5 Stock Photos',
//             '5 Page Website',
//             '3 Banner Design',
//             '1 jQuery Slider Banner',
//             'FREE Google Friendly Sitemap',
//             'Complete W3C Certified HTML',
//             '100% Satisfaction Guarantee',
//             '100% Unique Design Guarantee',
//             'Mobile Responsive will be Additional $200*',
//             'CMS will be Additional $250*'
//         ]
//     },
//     {
//         title: 'Professional',
//         originalPrice: '1688',
//         price: '844',
//         btnText: 'Get Started',
//         featuresHeading: 'Perfect for Describe who it fits',
//         featuresList: [
//             '10 Unique Pages Website',
//             'CMS / Admin Panel Support',
//             '8 Stock images',
//             '5 Banner Designs',
//             '1 jQuery Slider Banner',
//             'FREE Google Friendly Sitemap',
//             'Complete W3C Certified HTML',
//             'Complete Deployment',
//             '100% Satisfaction Guarantee',
//             '100% Unique Design Guarantee',
//             'Mobile Responsive will be Additional $200*'
//         ]
//     },
//     {
//         title: 'Elite',
//         originalPrice: '2988',
//         price: '1494',
//         btnText: 'Get Started',
//         featuresHeading: 'Perfect for Describe who it fits',
//         featuresList: [
//             'Upto 15 Unique Pages Website',
//             'Conceptual and Dynamic Website',
//             'Mobile Responsive',
//             'Online Reservation/Appointment Tool ',
//             'Online Payment Integration ',
//             'Custom Forms',
//             'Lead Capturing Forms ',
//             'Striking Hover Effects',
//             'Newsletter Subscription ',
//             'Newsfeed Integration',
//             'Social Media Integration',
//             'Search Engine Submission',
//             '5 Stock Photos',
//             '3 Unique Banner Design',
//             '1 jQuery Slider Banner',
//             ' Complete W3C Certified HTML',
//             'Complete Deployment',
//             '100% Satisfaction Guarantee',
//             '100% Unique Design Guarantee'
//         ]
//     },
//     {
//         title: 'Corporate',
//         originalPrice: '4788',
//         price: '2394',
//         btnText: 'Get Started',
//         featuresHeading: 'Perfect for Describe who it fits',
//         featuresList: [
//             '15 to 20 Pages Website',
//             'Custom Made, Interactive, Dynamic &amp; High End Design',
//             'Custom WP (or) Custom PHP Development',
//             '1 jQuery Slider Banner',
//             'Up to 10 Custom Made Banner Designs',
//             '10 Stock Images',
//             'Unlimited Revisions',
//             'Special Hoover Effects',
//             'Content Management System (CMS)',
//             'Online Appointment/Scheduling/Online Ordering Integration (Optional)',
//             'Online Payment Integration (Optional)',
//             'Multi Lingual (Optional)',
//             'Custom Dynamic Forms (Optional)',
//             'Signup Area (For Newsletters, Offers etc.)',
//             'Search Bar',
//             'Live Feeds of Social Networks integration (Optional)',
//             'Mobile Responsive',
//             'FREE 5 Years Domain Name',
//             'Free Google Friendly Sitemap',
//             'Search Engine Submission',
//             'Complete W3C Certified HTML',
//             'Industry Specified Team of Expert Designers and Developers',
//             'Complete Deployment',
//             'Dedicated Accounts Manager',
//             '100% Ownership Rights',
//             '100% Satisfaction Guarantee',
//             '100% Unique Design Guarantee',
//             '100% Money Back Guarante'
//         ]
//     },
// ]
export const customWebsitePackages = [
    {
        title: `Promo Website Package`,
        originalPrice: `488.00`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '194',
        btnText: 'Get Started',
        featuresList: [

            `2 Page Website`,
            `2 Stock Images`,
            `1 jQuery Slider Banner`,
            `Contact/Query Form`,
            `48 to 72 hours TAT`,
            `Complete Deployment`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`,
            `100% Money Back Guarantee *`,
        ]

    },
    {
        title: `Basic Website Package`,
        originalPrice: `488`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '294',
        btnText: 'Get Started',
        featuresList: [
            `2 Stock Images`,
            `3 Page Website`,
            `1 jQuery Slider Banner`,
            `Contact/Query Form`,
            `Complete W3C Certified HTML`,
            `Complete Deployment`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`
        ]

    },
    {
        title: `Startup Website Package`,
        originalPrice: `788`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '394',
        btnText: 'Get Started',
        featuresList: [
            `5 Stock Photos`,
            `5 Page Website`,
            `3 Banner Design`,
            `1 jQuery Slider Banner`,
            `FREE Google Friendly Sitemap`,
            `SUMMARY`,
            `Complete W3C Certified HTML`,
            `48 to 72 hours TAT`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`,
            `100% Money Back Guarantee *`,
            `Mobile Responsive will be Additional $200*`,
            `CMS will be Additional $250*`
        ]

    },
    {
        title: `Professional Website Package`,
        originalPrice: `1,688`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '844',
        btnText: 'Get Started',
        featuresList: [
            `10 Unique Pages Website`,
            `CMS / Admin Panel Support`,
            `8 Stock images`,
            `5 Banner Designs`,
            `1 jQuery Slider Banner`,
            `FREE Google Friendly Sitemap`,
            `Complete W3C Certified HTML`,
            `Complete Deployment`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`,
            `Mobile Responsive will be Additional $200*`
        ]

    },
    {
        title: `Elite Website Package`,
        originalPrice: `2,988`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '1,494',
        btnText: 'Get Started',
        featuresList: [
            `Upto 15 Unique Pages Website`,
            `Conceptual and Dynamic Website`,
            `Mobile Responsive`,
            `Online Reservation/Appointment Tool (Optional)`,
            `Online Payment Integration (Optional)`,
            `Custom Forms`,
            `Lead Capturing Forms (Optional)`,
            `Striking Hover Effects`,
            `Newsletter Subscription (Optional)`,
            `Newsfeed Integration`,
            `Social Media Integration`,
            `Search Engine Submission`,
            `5 Stock Photos`,
            `3 Unique Banner Design`,
            `1 jQuery Slider Banner`,
            `Complete W3C Certified HTML`,
            `Complete Deployment`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`
        ]

    },
    {

        title: `Corporate Website Package`,
        originalPrice: `4,788`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '2,394',
        btnText: 'Get Started',
        featuresList: [
            `15 to 20 Pages Website`,
            `Custom Made, Interactive, Dynamic & High End Design`,
            `Custom WP(or) Custom PHP Development`,
            `1 jQuery Slider Banner`,
            `Up to 10 Custom Made Banner Designs`,
            `10 Stock Images`,
            `Unlimited Revisions`,
            `Special Hoover Effects`,
            `Content Management System(CMS)`,
            `Online Appointment / Scheduling / Online Ordering Integration(Optional)`,
            `Online Payment Integration(Optional)`,
            `Multi Lingual(Optional)`,
            `Custom Dynamic Forms(Optional)`,
            `Signup Area(For Newsletters, Offers etc.)`,
            `Search Bar`,
            `Live Feeds of Social Networks integration(Optional)`,
            `Mobile Responsive`,
            `FREE 5 Years Domain Name`,
            `Free Google Friendly Sitemap`,
            `Search Engine Submission`,
            `Complete W3C Certified HTML`,
            `Industry Specified Team of Expert Designers and Developers`,
            `Complete Deployment`,
            `Dedicated Accounts Manager`,
            `100 % Ownership Rights`,
            `100 % Satisfaction Guarantee`,
            `100 % Unique Design Guarantee`
        ]

    },
    {

        title: `Business Website Package`,
        originalPrice: `5,998`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '2,999',
        btnText: 'Get Started',
        featuresList: [
            `15 Seconds 2D Explainer Video`,
            `Voice - Over & Sound Effects`,
            `Professional Script Writing`,
            `1 jQuery Slider Banner`,
            `Up to 10 Custom Made Banner Designs`,
            `Storyboard`,
            `SEO Meta Tags`,
            `15 to 20 Pages Website`,
            `Custom Made, Interactive, Dynamic & High End Design`,
            `Custom WP (or) Custom PHP Development`,
            `1 jQuery Slider Banner`,
            `Up to 10 Custom Made Banner Designs`,
            `10 Stock Images`,
            `Unlimited Revisions`,
            `Special Hoover Effects`,
            `Content Management System (CMS)`,
            `Online Appointment/Scheduling/Online Ordering Integration (Optional)`,
            `Online Payment Integration (Optional)`,
            `Multi Lingual (Optional)`,
            `Custom Dynamic Forms (Optional)`,
            `Signup Area (For Newsletters, Offers etc.)`,
            `Search Bar`,
            `Live Feeds of Social Networks integration (Optional)`,
            `Mobile Responsive`,
            `FREE 5 Years Domain Name`,
            `Free Google Friendly Sitemap`,
            `Search Engine Submission`,
            `Complete W3C Certified HTML`,
            `Industry Specified Team of Expert Designers and Developers`,
            `Complete Deployment`,
            `Dedicated Accounts Manager`,
            `100% Ownership Rights`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`,
        ]

    }
]
export const ecommerceWebsitePackages = [
    {
        title: `Startup E-Commerce Package`,
        originalPrice: `1,588`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '794',
        btnText: 'Get Started',
        featuresList: [
            `Customized Design`,
            `Up-to 100 Products`,
            `Content Management System (CMS)`,
            `Mini Shopping Cart Integration`,
            `Payment Module Integration`,
            `Easy Product Search`,
            `Dedicated designer & developer`,
            `Unlimited Revisions`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`
        ]

    },
    {
        title: `Professional E-Commerce Package`,
        originalPrice: `2,788`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '1,394',
        btnText: 'Get Started',
        featuresList: [
            `Customized Design`,
            `Up-to 500 Products`,
            `Content Management System (CMS)`,
            `Full Shopping Cart Integration`,
            `Payment Module Integration`,
            `Easy Product Search`,
            `Product Reviews`,
            `5 Promotional Banners`,
            `Team of Expert Designers & Developers`,
            `Unlimited Revisions`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`

        ]

    },
    {
        title: `Elite E-Commerce Package`,
        originalPrice: `7,388`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '3,694',
        btnText: 'Get Started',
        featuresList: [
            `UNLIMITED Logo Design Concepts`,
            `By 6 Award Winning Designers`,
            `Icon Design`,
            `UNLIMITED Revisions`,
            `Print Media`,
            `Stationary Design (BusinessCard,Letterhead & Envelope)`,
            `Invoice Design, Email Signature`,
            `Bi-Fold Brochure (OR) 2 Sided Flyer Design`,
            `Product Catalog Design`,
            `Sign age Design (OR) Label Design`,
            `T-Shirt Design (OR) Car Wrap Design`,
            `Website`,
            `E-Commerce Store Design`,
            `Product Detail Page Design`,
            `Unique Banner Slider`,
            `Featured Products Showcase`,
            `Full Shopping Cart Integration`,
            `Unlimited Products`,
            `Unlimited Categories`,
            `Product Rating & Reviews`,
            `Easy Product Search`,
            `Payment Gateway Integration`,
            `Multi-currency Support`,
            `Content Management System`,
            `Cutomer Log-in Area`,
            `Mobile Responsive`,
            `Social Media Plugins Integration`,
            `Coupon Platfom`,
            `Tell a Friend Feature`,
            `Social Media Pages`,
            `Facebook , Twitter, YouTube, Google+ & Pinterest Page Designs`,
            `Value Added Services`,
            `Dedicated Account Manager`,
            `Unlimited Revisions`,
            `All Final File Formats`,
            `100% Ownership Rights`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`
        ]

    }
]
export const wordpressWebsitePackages = [
    {
        title: 'Basic Package',
        originalPrice: `478`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '239',
        btnText: 'Get Started',
        featuresList: [
            `3 Page Website`,
            `2 Stock Images`,
            `1 jQuery Slider Banner`,
            `Contact/Query Form`,
            `48 to 72 hours TAT`,
            `Complete Deployment`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`,
            `100% Money Back Guarantee *`
        ]

    },
    {
        title: 'Startup Package',
        originalPrice: `788`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '394',
        btnText: 'Get Started',
        featuresList: [
            `5 Page Website`,
            `5 Stock Photos`,
            `3 Banner Design`,
            `1 jQuery Slider Banner`,
            `FREE Google Friendly Sitemap`,
            `Complete W3C Certified HTML`,
            `48 to 72 hours TAT`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`,
            `100% Money Back Guarantee *`,
            `Mobile Responsive will be Additional $200*`,
            `CMS will be Additional $250*`,
        ]

    },
    {
        title: 'Professional Package',
        originalPrice: `1,388`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '694',
        btnText: 'Get Started',
        featuresList: [
            `10 Unique Pages Website`,
            `CMS / Admin Panel Support`,
            `8 Stock images`,
            `5 Banner Designs`,
            `Mobile Responsive`,
            `1 jQuery Slider Banner`,
            `FREE Google Friendly Sitemap`,
            `Complete W3C Certified HTML`,
            `48 to 72 hours TAT`,
            `Complete Deployment`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`,
            `100% Money Back Guarantee *`
        ]

    },

    {
        title: 'Elite Package',
        originalPrice: `2,498`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '1,249',
        btnText: 'Get Started',
        featuresList: [
            'Upto 15 Unique Pages Website',
            'Conceptual and Dynamic Website',
            'Mobile Responsive',
            'Online Reservation/Appointment Tool ',
            'Online Payment Integration ',
            'Custom Forms',
            'Lead Capturing Forms ',
            'Striking Hover Effects',
            'Newsfeed Integration',
            'Social Media Integration',
            'Search Engine Submission',
            '5 Stock Photos',
            '3 Unique Banner Design',
            '1 jQuery Slider Banner',
            ' Complete W3C Certified HTML',
            '48 to 72 hours TAT',
            'Complete Deployment',
            '100% Satisfaction Guarantee',
            '100% Unique Design Guarantee',
            '100% Money Back Guarantee ',


        ]

    },
    {
        title: 'Business Package',
        originalPrice: `6,588`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '3,294',
        btnText: 'Get Started',
        featuresList: [
            `15 to 20 Pages Website`,
            `15 Seconds 2D Explainer Video`,
            `Voice - Over &amp;amp; Sound Effects`,
            `Professional Script Writing`,
            `Storyboard`,
            `SEO Meta Tags`,
            `Custom Made, Interactive, Dynamic &amp;amp; High End Design`,
            `Custom WP (or) Custom PHP Development`,
            `1 jQuery Slider Banner`,
            `Up to 10 Custom Made Banner Designs`,
            `10 Stock Images`,
            `Unlimited Revisions`,
            `Special Hoover Effects`,
            `Content Management System `,
            `Online Appointment/Scheduling/Online Ordering Integration`,
            `Online Payment Integration`,
            `Multi Lingual`,
            `Custom Dynamic Forms`,
            `Signup Area`,
            `Search Bar`,
            `Live Feeds of Social Networks integration`,
            `Mobile Responsive`,
            `FREE 5 Years Domain Name`,
            `Free Google Friendly Sitemap`,
            `Search Engine Submission`,
            `Complete W3C Certified HTML`,
            `Industry Specified Team of Expert Designers and Developers`,
            `Complete Deployment`,
            `Dedicated Accounts Manager`,
            `100% Ownership Rights`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`,
            `100% Money Back Guarantee `
        ]

    },
    {
        title: 'Business',
        originalPrice: 500,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '3,294',
        btnText: 'Get Started',
        featuresList: [
            '15 to 20 Pages Website',
            '15 Seconds 2D Explainer Video',
            'Voice - Over &amp; Sound Effects',
            'Professional Script Writing',
            'Storyboard',
            'SEO Meta Tags',
            'Custom Made, Interactive, Dynamic &amp; High End Design',
            'Custom WP (or) Custom PHP Development',
            '1 jQuery Slider Banner',
            'Up to 10 Custom Made Banner Designs',
            '10 Stock Images',
            'Unlimited Revisions',
            'Special Hoover Effects',
            'Content Management System ',
            'Online Appointment/Scheduling/Online Ordering Integration',
            'Online Payment Integration',
            'Multi Lingual',
            'Custom Dynamic Forms',
            'Signup Area',
            'Search Bar',
            'Live Feeds of Social Networks integration',
            'Mobile Responsive',
            'FREE 5 Years Domain Name',
            'Free Google Friendly Sitemap',
            'Search Engine Submission',
            'Complete W3C Certified HTML',
            'Industry Specified Team of Expert Designers and Developers',
            'Complete Deployment',
            'Dedicated Accounts Manager',
            '100% Ownership Rights',
            '100% Satisfaction Guarantee',
            '100% Unique Design Guarantee',
            '100% Money Back Guarantee ',


        ]

    }
]
export const mobileAppPackages = [
    {
        title: 'Business Apps Package',
        originalPrice: `4,999`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '2,499',
        btnText: 'Get Started',
        featuresList: [
            `15 to 20 Pages Website`,
            `Custom Made, Interactive, Dynamic &amp;amp; High End Design`,
            `Custom WP (or) Custom PHP Development`,
            `1 jQuery Slider Banner`,
            `Up to 10 Custom Made Banner Designs`,
            `10 Stock Images`,
            `Unlimited Revisions`,
            `Special Hoover Effects`,
            `Content Management System (CMS)`,
            `Online Appointment/Scheduling/Online Ordering Integration (Optional)`,
            `Online Payment Integration (Optional)`,
            `Multi Lingual (Optional)`,
            `Custom Dynamic Forms (Optional)`,
            `Signup Area (For Newsletters, Offers etc.)`,
            `Search Bar`,
            `Live Feeds of Social Networks integration (Optional)`,
            `Mobile Responsive`,
            `15 Seconds 2D Explainer Video`,
            `Voice - Over &amp;amp; Sound Effects`,
            `Professional Script Writing`,
            `Storyboard`,
            `SEO Meta Tags`,
            `FREE 5 Years Domain Name`,
            `Free Google Friendly Sitemap`,
            `Search Engine Submission`,
            `Complete W3C Certified HTML`,
            `Industry Specified Team of Expert Designers and Developers`,
            `Complete Deployment`,
            `Dedicated Accounts Manager`,
            `100% Ownership Rights`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`
        ]

    },
    {
        title: 'Automated/Interactive Conferencing Portal Package',
        originalPrice: `9,999`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '4,999',
        btnText: 'Get Started',
        featuresList: [
            `Unlimited Page Website`,
            `Custom Content Management System (CMS)`,
            `Unique Pages and UI Design`,
            `Complete Custom Development`,
            `Process Automation Tools`,
            `Newsfeed Integration`,
            `Social Media Plugins Integration`,
            `Upto 40 Stock images`,
            `10 Unique Banner Designs`,
            `JQuery Slider`,
            `Search Engine Submission`,
            `Free Google Friendly Sitemap`,
            `FREE 5 Years Hosting`,
            `Custom Email Addresses`,
            `Social Media Page Designs (Facebook, Twitter, Instagram)`,
            `Complete W3C Certified HTML`,
            `Complete Deployment`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`,
            `Money Back Guarantee`,
            `Key features`,
            `Automated Course Creation`,
            `Video Conferencing`,
            `Skills/Certification Tracking`,
            `Mobile Learning`,
            `Asynchronous Learning`,
            `CRM Features`,
            `Gamification`,
            `Social Learning/Message Boards`,
            `Motivational Triggers`,
            `Forums And Webinars`,
            `E-commerce And Subscriptions`,
            `Online Course Booking`,
            `Excellent Reporting`,
            `Invoicing Integration`,
            `Financial Integrations`,
            `Student Information management`,
            `Automated communications`,
            `Learning Management System`,
            `Quick And Easy Course Scheduling`,
            `Reporting And Data Analysis`,
            `Assessment Management &amp;amp; Live Feedback`,
            `Gradebooks`,
            `Quick User Integration`,
            `Easy Payment Methods`,
            `Online Communities &amp;amp; Social Engagement`,
            `Curation of Resources And Adding Own Resources`
        ]

    },


    {
        title: 'Automated/Interactive E-Commerce Package',
        originalPrice: `15999`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '7,999',
        btnText: 'Get Started',
        featuresList: [
            `Unlimited Page Website`,
            `Custom Content Management System(CMS)`,
            `Unique Pages and UI Design`,
            `Complete Custom Development`,
            `Process Automation Tools`,
            `Newsfeed Integration`,
            `Social Media Plugins Integration`,
            `Upto 40 Stock images`,
            `10 Unique Banner Designs`,
            `JQuery Slider`,
            `Search Engine Submission`,
            `Free Google Friendly Sitemap`,
            `FREE 5 Years Hosting`,
            `Custom Email Addresses`,
            `Social Media Page Designs(Facebook, Twitter, Instagram)`,
            `Complete W3C Certified HTML`,
            `Complete Deployment`,
            `100 % Satisfaction Guarantee`,
            `100 % Unique Design Guarantee`,
            `Money Back Guarantee`,
            `Automated Inventory / Shipping / Supplier`,
            `Manage thousands to millions of inventory with ease and check stock levels in real - time.Receive low inventory notifications and generate purchase orders to replenish your stock.`,
            `Suppliers Integration(API NEEDED)`,
            `Shipper Integration(API NEEDED)`,
            `Order management`,
            `LOT numbers and expire date tracking`,
            `Transfer stock between warehouses(If Warehouse - API NEEDED)`,
            `Receive stock into a specific warehouse(If Warehouse - API NEEDED)`,
            `Fulfill orders from a particular warehouse(If Warehouse - API NEEDED)`,
            `Stock Management`,
            `Actionable Insights`,
            `Real - Time Visibility`,
            `Inventory Opportunities`,
            `Advanced Features: (API Needed For Suppliers / Warehouse)`,
            `Speak to suppliers during trivial conversations.`,
            `Set and send actions to suppliers regarding governance and compliance`,
            `materials.`,
            `Place purchasing requests.`,
            `Research and answer internal questions regarding procurement functionalities or a supplier / supplier set.`,
            `Receiving / filing / documentation of invoices and payments / order requests`,
            `Machine Learning(ML) for Supply Chain Planning(SCP)`,
            `Machine Learning for Warehouse Management`,
            `Natural Language Processing(NLP) for Data Cleansing and Building DatRobustness`,
            `Automated Invoices &amp; amp; Estimates`,
            `Create beautiful, professional invoices &amp; amp; estimates in just a few secondanthen instantly email them as PDF's directly to your customers or prospects.`,
            `Automated Split invoicing`,
            `Automated Combine invoices`,
            `Invoice templates`,
            `Automated Barcode Scanning`,
            `Scan inventory into your orders, generate barcodes for your documents, and`,
            `search for inventory or documents by scanning barcodes.`,
            `Locations and Zones`,
            `Have multiple warehouses, offices, or retail stores ? No problem.Easily track where all your inventory is by organizing everything into locations and zones.`,
            `Organize inventory items using custom attributes such as size, color, and, location.View how many you have globally or at each,location.`,
            `Customer Accounts`,
            `Performance and analytics`,
            `Customization of Personal Details`,
            `Process management`,
            `Sales Automation`,
            `Team Collaboration`,
            `Marketing Automation`,
            `Security`,
            `Integrations`,
            `Mobile Notifications`,
            `Sales Reports`,
            `Trend Analytics`,
            `Forecasting`,
            `Territory Management`,
            `Account Management`,
            `Event Integration`,
            `Advanced Data Security`,
            `Purchase Orders`,
            `With integrated purchase orders, you can easily replenish your inventory`,
            `levels`,
            `by ordering more stock and even track when those new items will arrive.`,
            `Partial orders fulfill`,
            `Backordering`,
            `Financial Reports`,
            `Generate extremely detailed reports for your inventory, sales and services.`,
            `Filter your reports by date - range and category to see what's making you the,most money`
        ]

    },
]

export const shopifyAppPackages = [
    {
        title: `STARTUP SHOPIFY PACKAGE`,
        originalPrice: `1,598`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '799',
        btnText: 'Get Started',
        featuresList: [
            `Customized Design`,
            `Up - to 100 Products`,
            `Content Management System(CMS)`,
            `Full Shopping Cart Integration`,
            `Payment Module Integration`,
            `Easy Product Search`,
            `Dedicated Designer & Developer`,
            `Unlimited Revisions`,
            `100 % Satisfaction Guarantee`,
            `100 % Unique Design Guarantee`,
            `100 % Money Back Guarantee *`
        ]

    },
    {
        title: `PROFESSIONAL SHOPIFY PACKAGE`,
        originalPrice: `2,798`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '1399',
        btnText: 'Get Started',
        featuresList: [
            `Customized Design`,
            `Up-to 500 Products`,
            `Dropshipping`,
            `Content Management System (CMS)`,
            `Full Shopping Cart Integration`,
            `Payment Module Integration`,
            `Easy Product Search`,
            `Product Reviews`,
            `5 Promotional Banners`,
            `Team Of Expert Designers Developers`,
            `Unlimited Revisions`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`,
            `100% Money Back Guarantee*`
        ]

    },


    {
        title: `ELITE SHOPIFY PACKAGE`,
        originalPrice: `4,998`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '2499',
        btnText: 'Get Started',
        featuresList: [
            `Unlimited Pages Website with Unique Design`,
            `5 Custom Logo Design`,
            `CMS / Backend Adminstrative System`,
            `Unlimited Products with Unlimited Categories`,
            `FREE Unlimited Revisions`,
            `Custom Shopping Cart Integration`,
            `Multiple Payment Module Integration`,
            `Multiple Shipping Module Integration`,
            `Product Ratings & Reviews`,
            `Sales & Inventory Management System`,
            `Multiple Currency Support`,
            `Customer Login Area (Sign-Up & Sign-In)`,
            `Mobile Responsive`,
            `Social Media Designs (Facebook, Twitter, Youtube)`,
            `Dedicated Team of Expert Designers & Developers`,
            `Dedicated Project Manager`,
            `News Letter Subscription`,
            `100% Satisfaction Guarantee`,
            `100% Unique Design Guarantee`,
            `100% Money Back Guarantee*`
        ]

    },

    {
        title: `BUSINESS SHOPIFY PACKAGE`,
        originalPrice: `9,998`,
        featuresHeading: 'Perfect for Describe who it fits',
        price: '4999',
        btnText: 'Get Started',
        featuresList: [
            `Complete Custom Design & Development`,
            `Unique, User Friendly, Interactive, Dynamic, High End UI Design`,
            `Unlimited Banner Designs`,
            `Interactive Sliding Banners`,
            `Special Hover Effects`,
            `Customized Contact us Form`,
            `Multiple Filtration Option (Search by Age, Experience, Talent, Industry etc)`,
            `Profile Comparison (As per Category)`,
            `File Converter`,
            `Custom Video Functionality`,
            `Multiple File format Uploading`,
            `User Signup Area ( Talent )`,
            `User Signup Area ( Casting )`,
            `User Signup Area ( Agency )`,
            `Client/User Dashboard Area`,
            `Vendor / Agency Dashboard Area`,
            `Custom Coding and Development`,
            `Content Management System (Custom)`,
            `Online Appointment/Scheduling integration (Optional)`,
            `Online Payment Integration`,
            `Invoicing System`,
            `Automated Email Notifications`,
            `Multi Lingual (Optional)`,
            `Custom Dynamic Forms`,
            `Complete Database Creation`,
            `3rd Party Links integration (Instagram, IMDB etc )`,
            `Signup Automated Email Authentication`,
            `Signup Area (For Newsletters, Offers etc.)`,
            `Search Bar for Easy Search`,
            `Live Feeds of Social Networks integration (Optional)`,
            `Search Engine Submission`,
            `SEO friendly`,
            `Mobile Responsive`,
            `Master Admin Panel`,
            `SSL Certification ( to make the website and its informative secured )1 Year Free Hosting`,
            `6 Months of Free Maintenance`,
            `Award-Winning Team of Expert Designers and Developers`,
            `Complete Deployment`,
            `Complete W3C Validation`,
            `Dedicated Team of Designers and Developers`

        ]

    }
]
export const packagesCate = [
    {
        key: '0',
        label: 'Custom Website',
        title: 'Custom Website Development',
        packages: customWebsitePackages
    },
    {
        key: '1',
        label: 'Ecommerce',
        title: 'Ecommerce Website Development',
        packages: ecommerceWebsitePackages
    },
    {
        key: '2',
        label: 'Wordpress',
        title: 'WordPress Website Packages',
        packages: wordpressWebsitePackages
    },
    {
        key: '3',
        label: 'Mobile App',
        title: 'Mobile Application Development',
        packages: mobileAppPackages
    },
    {
        key: '4',
        label: 'Shopify',
        title: 'Shopify Website Development',
        packages: shopifyAppPackages
    }
]